import { render, staticRenderFns } from "./SkipPageGreen.vue?vue&type=template&id=4858fa05&scoped=true&"
import script from "./SkipPageGreen.vue?vue&type=script&lang=js&"
export * from "./SkipPageGreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858fa05",
  null
  
)

export default component.exports